import React, { useEffect, useState } from "react";
import "./services.css";
import audit from "../../assets/services/audit1.png";
import cloud from "../../assets/services/cloud1.png";
import networking from "../../assets/services/networking1.png";
import online from "../../assets/services/online1.png";
import management from "../../assets/services/management.png";
import market from "../../assets/services/market.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Services = () => {
  const [mobileVersion, setMobileVersion] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setMobileVersion(window.innerWidth <= 980);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          // Calculate the exact offset we want
          const offset = window.innerWidth <= 768 ? -85 : -205; // Fine-tuned values
          
          // Get element's position
          const elementPosition = element.getBoundingClientRect().top;
          
          // Calculate final position
          const offsetPosition = elementPosition + window.pageYOffset + offset;
          
          // Smooth scroll to adjusted position
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, []);

  return (
    <main id={mobileVersion ? "services-mb" : "services"}>
      <motion.h2
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="services-title"
      >
        SERVICES
      </motion.h2>
      <div className="contact-divider" />

      {/* First service - text right, image left (default) */}
       <div id={mobileVersion ? "first-partmb" : "first-part"}>
        <div className="text">
          <h1 id="directsearch">Direct Search</h1>
          <p>
            As a boutique executive search firm, we specialize in filling complex, high-level positions through a discreet, precise, and highly personalized process. Drawing on extensive experience and a trusted international network, we identify candidates who align not only with your requirements but also with your culture. Trust, discretion, and individual focus define our work.
          </p>
          <p><strong>Active Sourcing</strong></p>
          <p>
            We go where top talent is - before they enter the market. With smart data, targeted outreach, and a real feel for timing, we engage specialists who aren't actively applying but are ready for their next step. Our sourcing turns passive profiles into active matches - focused, relevant, and fast.
          </p>
        </div>
        <div className="pic">
          <img src={online} alt="Direct Search" />
        </div>
      </div>

      {/* Second service - image right, text left (reversed) */}
      <div id={mobileVersion ? "first-partmb" : "first-part"} className="reverse">
        <div className="pic">
          <img src={cloud} alt="" />
        </div>
        <div className="text">
          <h1 id="cloud">Cloud-based candidate pools</h1>
          <p>
            Our cloud-based candidate pools offer a flexible and secure platform for managing and tracking recruitment projects. Originally developed for a renowned German sports car manufacturer, this solution has since been expanded and adapted for a wide range of clients.
            Ideal for projects with undefined or evolving hiring needs, our system allows for the early identification and structured organization of candidate profiles across various areas of expertise.
            Within just a few months, we build a highly qualified pool of potential candidates that can be flexibly leveraged in future selection processes - regardless of whether the final structure, number of positions, or job descriptions have already been determined.
            This gives you early access to top talent - precisely when your hiring needs become concrete.
          </p>
        </div>
      </div>

      {/* Third service - text right, image left (default) */}
      <div id={mobileVersion ? "first-partmb" : "first-part"}>
        <div className="text">
          <h1 id="knowledge">Knowledge Tagging / Market analysis</h1>
          <p>
            With our expertise in market analysis and targeted knowledge tagging, we help organizations identify global thought leaders and innovators in specific fields.
            Who is shaping the future of artificial intelligence? Who is leading the way in electric mobility?
            To answer such questions, we have consistently invested in resources over the past decade, developing a deep understanding of global knowledge landscapes.
            As a long-term partner, we take responsibility for international market analysis and the targeted search for key individuals and institutions driving research and innovation in their respective domains. Our goal is to give you a clear overview of relevant trends and developments - building a solid foundation for your strategic decisions.
          </p>
        </div>
        <div className="pic">
          <img src={networking} alt="" />
        </div>
      </div>

      {/* Fourth service - image right, text left (reversed) */}
      <div id={mobileVersion ? "first-partmb" : "first-part"} className="reverse">
        <div className="pic">
          <img src={audit} alt="" />
        </div>
        <div className="text">
          <h1 id="audit">Performance Audits</h1>
          <p>
            Our performance audits offer in-depth evaluations of individual, process-level, or organizational performance and effectiveness.
            We not only assess existing strengths and weaknesses but also identify specific areas for improvement and action.
            These audits can be conducted as stand-alone services or in combination with other analytical tools. In addition to identifying optimization potential, we provide actionable recommendations - highlighting how existing strengths can be better utilized or redirected to maximize efficiency and goal achievement in your organization.
          </p>
        </div>
      </div>

      {/* Fifth service - text right, image left (default) */}
      <div id={mobileVersion ? "first-partmb" : "first-part"}>
        <div className="text">
          <h1 id="market">Market Entries</h1>
          <p>
            With our expertise in market entry strategies, we help companies successfully expand
            into new markets - particularly in Eastern Europe and the Balkans.
            We support your business in analyzing local market conditions, identifying
            opportunities, and planning a sustainable growth strategy.

            Additionally, we offer interim management to oversee the establishment and leadership
            of new international subsidiaries.
            Our focus is on creating locally grounded, globally minded organizations. We take
            regional specifics and long-term success factors into account to ensure a smooth and
            effective expansion process.   </p>
        </div>
        <div className="pic">
          <img src={market} alt="" />
        </div>
      </div>

      {/* Sixth service - image right, text left (reversed) */}
      <div id={mobileVersion ? "first-partmb" : "first-part"} className="reverse">
        <div className="pic">
          <img src={management} alt="" />
        </div>
        <div className="text">
          <h1 id="interim">Interim Management</h1>
          <p>
            Our interim management service gives companies the flexibility to access leadership expertise on short notice - during transition phases, for specific projects, or when an urgent need for know-how arises.
            We maintain a strong network of qualified interim managers, especially in the finance sector, who are ready to step in and deliver top-tier solutions.
            Our experienced professionals drive change, optimize processes, and guide your company through challenging phases with confidence.
            We ensure the right leaders are available at the right time to keep your business stable and forward-looking.
            This service is also available ahead of permanent searches - to support your organization through the transition and facilitate the selection of the best long-term candidate.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Services;